export default __webpack_public_path__ + "static/media/friend.825986f7.jfif";